module.exports = __webpack_public_path__ + "static/media/galerija_2017 (31).8a0c7e7a.jpg";